// --------------------------------------------------------
// src/views/bookCollection.view.js
//
// Manage the view/template of a BookCollection object
//
// Create a BookView for every Book objects in the
// collection
//
// --------------------------------------------------------
"use strict";

// The view for the book collection
const BookCollectionView = Backbone.View.extend({

	// The className for the $el container
	className: "col-lg-12 col-md-12, col-sm-12, col-xs-12 bookListContainer",
	
	perColumn: 4,

	initialize: function(options) {
		this.options = options || {};
		this.perColumn = options.column || this.perColumn;

		this.listenTo(this.collection, "update reset destroy", this.reRender);
		this.proxy = new Proxy(this, this.watcher);
	},

	reRender: function() {
		this.render();
		BookCollectionView.animate(".bookContainer");
	},

	// Render the template for every books in the collection
	render: function() {
		this.$el.empty();
		// Render a view for every books in the collection
		this.collection.each(this.addBook, this);

		return this;
	},

	setCollection: function(collection) {
		this.proxy.collection = collection;
	},

	// Append a new book template
	addBook: function(book) {
		// Create the view with the given book object
		var bc = new BookComponent({ model: book, width: this.perColumn });
		
		this.$el.append(bc.render().el);
	},

	watcher: {
		set: function(target, prop, newValue) {
			if (prop === "collection") {
				target.collection = newValue;
				target.reRender();

				return true;
			}

			return false;
		}
	}
});

// Animate a specific selector
BookCollectionView.animate = function(selector) {
	new TimelineMax()
		.staggerFrom(selector, 0.7, { y: 30, opacity: 0, ease: Power2.easeOut }, 0.1);
};
